/**
 * Metric Counter - Animated number counter
 * Extracted from Landing.tsx for reuse
 */

import { motion, useInView, useSpring, useTransform } from 'framer-motion';
import { useRef, useEffect, useState } from 'react';

export function MetricCounter({ 
  from, 
  to, 
  suffix = '', 
  prefix = '',
  duration = 2.5 
}: { 
  from: number; 
  to: number; 
  suffix?: string; 
  prefix?: string;
  duration?: number;
}) {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-100px' });
  const [hasAnimated, setHasAnimated] = useState(false);
  const [prefersReducedMotion, setPrefersReducedMotion] = useState(false);
  
  useEffect(() => {
    if (typeof window !== 'undefined') {
      const mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      setPrefersReducedMotion(mediaQuery.matches);
    }
  }, []);
  
  const springValue = useSpring(from, {
    stiffness: 30,
    damping: 25,
  });

  useEffect(() => {
    if ((isInView || prefersReducedMotion) && !hasAnimated) {
      setHasAnimated(true);
      springValue.set(to);
    }
  }, [isInView, hasAnimated, to, springValue, prefersReducedMotion]);

  const displayValue = useTransform(springValue, (latest) => {
    if (suffix === 'h') {
      return `${prefix}${latest.toFixed(1)}${suffix}`;
    }
    if (suffix === '%') {
      return `${prefix}${Math.round(latest)}${suffix}`;
    }
    return `${prefix}${Math.round(latest)}${suffix}`;
  });

  return (
    <motion.span ref={ref} className="text-3xl md:text-4xl lg:text-5xl font-semibold text-foreground tracking-tight">
      {hasAnimated ? <motion.span>{displayValue}</motion.span> : `${prefix}${from}${suffix}`}
    </motion.span>
  );
}

